<div class="gauge">
    <svg class="gauge-svg" viewBox="-24 -32 480 392" fill="none" aria-hidden="true">
        <defs>
            <filter [attr.id]="prefix + '-pill-blur'" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="2.25" />
            </filter>
            <filter
                [attr.id]="prefix + '-glow-inner'"
                filterUnits="userSpaceOnUse"
                x="27"
                y="27"
                width="379"
                height="288"
                color-interpolation-filters="sRGB"
            >
                <feGaussianBlur stdDeviation="7" />
            </filter>
            <radialGradient
                [attr.id]="prefix + '-track-green'"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(216 216) rotate(-90) scale(225.248 228.985)"
            >
                <stop offset="0.72" stop-color="rgba(0,255,122,0)" />
                <stop offset="0.89" stop-color="rgb(0,255,122)" />
            </radialGradient>
        </defs>

        <g class="gauge-ticks">
            @for (tick of ticks; track $index) {
                <line [attr.x1]="tick.x1" [attr.y1]="tick.y1" [attr.x2]="tick.x2" [attr.y2]="tick.y2" stroke="white" opacity="0.2" />
            }
        </g>
        <g class="gauge-scale">
            @for (mark of scale(); track $index) {
                <text [attr.x]="mark.x" [attr.y]="mark.y" text-anchor="middle" dominant-baseline="middle">{{ mark.label }}</text>
            }
        </g>

        <g class="gauge-arcs" [attr.transform]="arcsTransform()">
            <path
                class="track"
                d="M 66.811 297.502 A 170 170 0 1 1 365.189 297.502"
                [attr.stroke]="urls.trackGreen"
                stroke-width="12"
                stroke-linecap="round"
            />

            <g [attr.filter]="urls.glowInner" opacity="0.5">
                <path
                    #greenGlow
                    class="arc-glow"
                    d="M 66.811 297.502 A 170 170 0 1 1 365.189 297.502"
                    [attr.stroke]="urls.trackGreen"
                    stroke-width="12"
                    stroke-linecap="round"
                />
            </g>

            <path
                #greenValue
                class="arc-value"
                d="M 63.301 299.420 A 174 174 0 1 1 368.699 299.420"
                stroke="#65ce5c"
                stroke-width="8"
                stroke-linecap="round"
            />

            <g #greenPill class="arc-pill">
                <rect x="-3.9" y="-7" width="7.8" height="14" rx="3.9" fill="#8fffbc" opacity="0.4" [attr.filter]="urls.pillBlur" />
                <rect x="-3.6" y="-6.5" width="7.2" height="13" rx="3.6" fill="#65ce5c" />
            </g>
        </g>
    </svg>

    <p class="gauge-value">
        <span class="gauge-number">{{ displayed() }}</span
        ><span class="gauge-percent">%</span>
    </p>
</div>
